import { Component, inject, OnDestroy, OnInit,NgZone, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { SettingsService } from "../../../services/settings.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TableConfiguration } from "../../../shared/components/paginated-data-table/paginated-table-configuration.model";
import { ActionButton } from "../../../shared/components/paginated-data-table/action-button.model";
import { LayoutService } from "../../../shared/components/app-layout/shared-layout/layout.service";
import { filter, Observable, Subscription } from "rxjs";
import { StoreItemActions } from "../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../store/entities/store-item/store-item.model";
import { Store } from "@ngrx/store";
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { AppState } from "../../../store";
import * as AOS from 'aos';
import {
  DELETE_WAREHOUSE_MUTATION,
  GET_ALL_MSD_WAREHOUSE, GET_ALL_MSD_WAREHOUSE_DETAILED
} from "../../../store/entities/warehouse-management/warehouse/warehouse.graphql";
import { Warehouse } from "../../../store/entities/warehouse-management/warehouse/warehouse.model";
import { NotificationService } from "../../../services/notification.service";
import { WarehouseAddComponent } from "./warehouse-add/warehouse-add.component";
import { WarehouseAssignPersonComponent } from "./warehouse-view/warehouse-assignee-list/warehouse-assign-person/warehouse-assign-person.component";
import { selectStoreItems } from "../../../store/entities/store-item/store-item.selectors";
import {
  faEdit,
  faInfoCircle,
  faLayerGroup,
  faMicrochip,
  faToggleOff,
  faToggleOn,
  faTrash,
  faUsers,
  faUserTie,
  
} from "@fortawesome/free-solid-svg-icons";
import { NgxPermissionsService } from "ngx-permissions";

@Component({
  selector: "app-warehouses-list",
  templateUrl: "./warehouses-list.component.html",
  styleUrl: "./warehouses-list.component.scss",
})
export class WarehousesListComponent implements OnInit, OnDestroy {
  private settingsService: SettingsService = inject(SettingsService);
  private layoutService: LayoutService = inject(LayoutService);
  private activeRoute: ActivatedRoute = inject(ActivatedRoute);


  title: string;
  searchTerm: string = '';
  filteredWarehouses: Warehouse[] = [];
 
  currentPage = 'warehouses';

  tableData: Observable<any[]>;
  query;
  addPermission: string[] = ["can_create_warehouse"];
    isHovered: boolean = false;

  upsertAction = StoreItemActions.upsertStoreItem;
  removeAction = StoreItemActions.deleteStoreItem;

  refreshDataTable: boolean = false;
  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: 'name', label: 'Name' },
      { name: 'regionName', label: 'Region' },
      { name: 'districtName', label: 'District' },
      { name: 'wardName', label: 'Ward' },
    ],
    tableCaption: '',
    showNumbers: true,
    tableNotifications: 'Notification',
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: 'Activate',
    empty_msg: 'No data found',
  }

  actionButtons: ActionButton[] = [
    {
      id: 'more',
      label: 'View More',
      title: 'View More',
      class: '',
      icon: 'list',
      action: 'more',
      confirm_first: false,
      loading_message: ''
    },
    {
      id: 'edit',
      label: 'Edit',
      title: 'Edit',
      class: '',
      icon: 'edit',
      action: 'edit',
      confirm_first: false,
      loading_message: ''
    },
    {
      id: 'delete',
      label: 'Delete',
      title: 'Delete',
      class: '',
      icon: 'delete',
      action: 'delete',
      confirm_first: false,
      loading_message: ''
    },
  ];

  permissions = {
    more: ['can_view_warehouse'],
    edit: ['can_edit_warehouse'],
    delete: ['can_delete_warehouse'],
  }

  viewDetailsTitle: string;
  viewDetails: boolean;
  viewType: string;
  selectedUuid: string;

  routeSub = Subscription.EMPTY;
  warehouses: Warehouse[];


  constructor(
    private router: Router,
    private store: Store<AppState>,
    private notificationService: NotificationService,
       private permissionsService: NgxPermissionsService 
  ) { }

  ngOnInit() {
    this.title = "";
    this.fetchWarehouseDetails()
    this.viewDetailsTitle = '';
    this.routeSub = this.activeRoute.queryParams.subscribe(items => {
      this.viewDetails = !!items['action'];
      this.viewType = items['action'] ?? '';
      this.selectedUuid = items['id'] ?? '';
    });
     this.router.events.pipe(
    filter(event => event instanceof NavigationEnd)
  ).subscribe(() => {
    AOS.refresh();
  });
  }
 ngAfterViewInit() {
  AOS.init({ once: true });
}

ngAfterViewChecked() {
  AOS.refresh(); 
}
hasPermission(permission: string): boolean {
  return !!this.permissionsService.getPermission(permission);
}

 
  onAdd(warehouse: any = null) {
    this.settingsService.openDialogModal({
      component: WarehouseAddComponent,
      data: {
        warehouse: warehouse,
      },
    });
  }


  onView(evt: any) {
    this.layoutService.openPanel({ action: 'view', id: evt.uniqueId });

  }

  async closePanel(shouldUpdate = false) {
    this.layoutService.closePanel();
    await this.fetchWarehouseDetails()
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  mapFunction = (item: Warehouse) => {
    return {
      ...item,
      regionName: item?.region?.name,
      districtName: item?.distric?.name,
      wardName: item?.ward?.name,
    }
  }

  customAction(event: any) {
    if (event?.action == 'more') return this.onView(event?.value);
    if (event?.action == 'delete') return this.onDelete(event?.value);
    if (event?.action == 'edit') return this.onAdd(event?.value);
  }

  async onDelete(warehouse: Warehouse) {
    this.notificationService.confirmation({ message: 'Are you sure?' }).then(
      async (data) => {
        if (data) {
          this.store.dispatch(StoreItemActions.removeStoreItem({
            entity: StoreItemEntity.warehouse,
            input: {
              uniqueId: warehouse.uniqueId
            },
            id: warehouse?.id,
            mutation: DELETE_WAREHOUSE_MUTATION
          }))
        }
      }
    )
  }
  async fetchWarehouseDetails(): Promise<void> {
  this.store.dispatch(
    StoreItemActions.getStoreItems({
      filtering: {
        pageNumber: 1,
      },
      entity: StoreItemEntity.warehouse,
      query: GET_ALL_MSD_WAREHOUSE,
    })
  );
  this.store
    .select(selectStoreItems(StoreItemEntity.warehouse))
    .subscribe((res) => {
      if (Array.isArray(res)) {
        this.warehouses = res as Warehouse[];
        
        this.filteredWarehouses = [...this.warehouses];
      }
    });
}


onSearch() {
  if (!this.searchTerm.trim()) {
  
    this.fetchWarehouseDetails();
    return;
  }

  const filtered = this.warehouses.filter(w =>
    w.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    w.region?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    w.distric?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    w.ward?.name?.toLowerCase().includes(this.searchTerm.toLowerCase())
  );

  this.getData(filtered); 
}

onSearchIconClick() {
  if (!this.searchTerm.trim()) {
    this.fetchWarehouseDetails();
    return;
  }

  const filtered = this.warehouses.filter(w =>
    w.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    w.region?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    w.distric?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
    w.ward?.name?.toLowerCase().includes(this.searchTerm.toLowerCase())
  );

  this.getData(filtered);
}



  getData(data: Warehouse[]) {
    this.store.dispatch(StoreItemActions.loadStoreItems({ storeItems: data, entity: StoreItemEntity.warehouse }))
  }

  protected readonly faUserTie = faUserTie;
  protected readonly faLayerGroup = faLayerGroup;
  protected readonly faMicrochip = faMicrochip;
  protected readonly faInfoCircle = faInfoCircle;
  protected readonly faUsers = faUsers;
  protected readonly faTrash = faTrash;
  protected readonly faToggle = faToggleOn;
  protected readonly faEdit = faEdit;
}
